import { MarketRegion, ApiRegion, Features, MarketType, } from "../../contexts/MarketContext/MarketProvider";
export const ukMarket = {
    locale: "uk",
    marketName: "United Kingdom",
    countryCode: "gb",
    cmsLocale: "en_GB",
    languageCode: "en",
    languageName: "English",
    region: MarketRegion.Europe,
    apiRegion: ApiRegion.Global,
    dateFormat: "DD.MM.YYYY",
    features: [Features.EnableLogin],
    marketType: MarketType.PSU,
};
export const markets = [
    // Europe
    {
        locale: "fr-be",
        countryCode: "be",
        cmsLocale: "fr_BE",
        marketName: "Belgique | Français",
        languageCode: "fr",
        languageName: "Français",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "nl-be",
        marketName: "België | Nederlands",
        countryCode: "be",
        cmsLocale: "nl_BE",
        languageCode: "nl",
        languageName: "Vlaams",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "de",
        marketName: "Deutschland",
        countryCode: "de",
        cmsLocale: "de_DE",
        languageCode: "de",
        languageName: "Deutsch",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "nl",
        marketName: "Nederland",
        countryCode: "nl",
        cmsLocale: "nl_NL",
        languageCode: "nl",
        languageName: "Nederlands",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "no",
        countryCode: "no",
        cmsLocale: "nb_NO",
        marketName: "Norge",
        languageCode: "nb",
        languageName: "Norsk",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "YYYY.MM.DD",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "de-ch",
        countryCode: "ch",
        cmsLocale: "de_CH",
        marketName: "Schweiz | Deutsch",
        languageCode: "de",
        languageName: "Deutsch",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "fr-ch",
        countryCode: "ch",
        cmsLocale: "fr_CH",
        marketName: "Suisse | Français",
        languageCode: "fr",
        languageName: "Français",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "it-ch",
        countryCode: "ch",
        cmsLocale: "it_CH",
        marketName: "Svizzera | Italiano",
        languageCode: "it",
        languageName: "Italiano",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "DD.MM.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "se",
        marketName: "Sverige",
        countryCode: "se",
        cmsLocale: "sv_SE",
        languageCode: "sv",
        languageName: "Svenska",
        region: "Europe",
        apiRegion: "global",
        dateFormat: "YYYY.MM.DD",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    ukMarket,
    // North America
    {
        locale: "en-ca",
        marketName: "Canada | English",
        countryCode: "ca",
        cmsLocale: "en_CA",
        languageCode: "en",
        languageName: "English",
        region: "North America",
        apiRegion: "global",
        dateFormat: "MM.DD.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "fr-ca",
        marketName: "Canada | Français",
        countryCode: "ca",
        cmsLocale: "fr_CA",
        languageCode: "fr",
        languageName: "Français",
        region: "North America",
        apiRegion: "global",
        dateFormat: "YYYY.MM.DD",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "us",
        marketName: "United States",
        countryCode: "us",
        cmsLocale: "en_US",
        languageCode: "en",
        languageName: "English",
        region: "North America",
        apiRegion: "global",
        dateFormat: "MM.DD.YYYY",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    // Asia-Pacific
    {
        locale: "zh-cn",
        marketName: "中国",
        countryCode: "cn",
        cmsLocale: "zh_CN",
        languageCode: "zh",
        languageName: "中文",
        region: "Asia-Pacific",
        apiRegion: "china",
        dateFormat: "YYYY.MM.DD",
        features: ["enableLogin"],
        marketType: "PSU",
    },
    {
        locale: "kr",
        marketName: "대한민국",
        countryCode: "kr",
        cmsLocale: "ko_KR",
        languageCode: "ko",
        languageName: "한국어",
        region: "Asia-Pacific",
        apiRegion: "global",
        dateFormat: "YYYY.MM.DD",
        features: [],
        marketType: "PSU",
    },
    // Global
    {
        locale: "global",
        marketName: "Global",
        countryCode: "global",
        cmsLocale: "glb",
        languageCode: "en",
        languageName: "English",
        region: "global",
        apiRegion: "global",
        dateFormat: "YYYY.MM.DD",
        features: [],
        marketType: "PSU",
    },
];
export const getMockMarkets = () => markets;
